// removed by extract-text-webpack-plugin
module.exports = {"pie":"antd-pro-pie","chart":"antd-pro-chart","hasLegend":"antd-pro-hasLegend","legend":"antd-pro-legend","dot":"antd-pro-dot","line":"antd-pro-line","legendTitle":"antd-pro-legendTitle","percent":"antd-pro-percent","value":"antd-pro-value","title":"antd-pro-title","total":"antd-pro-total","legendBlock":"antd-pro-legendBlock"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Pie/index.less
// module id = 364
// module chunks = 0 1